const ns = typeof window === 'undefined' ? global : window

try {
  ns.Sentry = require('@sentry/react')
  const { EnrichSentryScope } = require('./lib/enrich-sentry-scope')
  const { getTracesSampleRate } = require('./lib/get-traces-sample-rate')
  const { BrowserTracing } = require('@sentry/tracing')

  Sentry.init({
    dsn: 'https://4ef7375851964bd1bd2bb051a26158d1@o1363869.ingest.sentry.io/4505195836866560',
    environment:
      typeof window !== 'undefined' && window?.__BL_ANALYTICS__?.environment,
    initialScope: EnrichSentryScope(__SENTRY_TRANSACTION_CONTEXT__),
    integrations: [new BrowserTracing()],
    release:
      typeof window !== 'undefined' && window?.__BL_ANALYTICS__?.app_version,
    sampleRate: 0.1,
    tracePropagationTargets: [
      'babylist.test',
      'www.babylist.test',
      'staging.babylist.com',
      'staging2.babylist.com',
      'staging3.babylist.com',
      'staging4.babylist.com',
      'staging5.babylist.com',
      'staging6.babylist.com',
      'babylist.com',
      'www.babylist.com',
    ],
    tracesSampler: (samplingContext) => {
      const {
        location: { host },
        transactionContext: { op },
      } = samplingContext

      return getTracesSampleRate(host, op)
    },
  })
} catch (e) {
  ns.Sentry = {
    configureScope: (func) => {
      func({
        setTag: (tag, value) => {
          console.log('Sentry.setTag(' + JSON.stringify([tag, value]) + ')')
        },
        setUser: (user) => {
          console.log('Sentry.setUser(' + JSON.stringify(user) + ')')
        },
        setTransactionName: (transaction) => {
          console.log(
            'Sentry.setTransactionName(' + JSON.stringify(transaction) + ')'
          )
        },
      })
    },
  }
}
